import React, { useState } from 'react'
import DataForm from './DataForm'
import DataViewTable from './DataViewTable'
import DataPageHeader from './DataPageHeader'
import { DataFormVal, IDataForm } from '../../models/Pharse2/Data';
import { useStore } from '../../stores/store';
import { OptionContainer } from '../../components/FormElement/MultiLevelSelectElement/MultiLevelSelectElement';

const hasLeq30Option = (options: OptionContainer[]): boolean => {
  for (const opt of options) {
    if (opt.name === 'Leq30') return true;
    for (const subOpt of opt.subOptions || []) {
      if (subOpt.name === 'Leq30') return true;
    }
  }
  return false;
}

const hasTSPOrPM10Option = (options: OptionContainer[]): boolean => {
    for (const opt of options) {
        if (opt.name === 'TSP' || opt.name === 'PM10') return true;
        for (const subOpt of opt.subOptions || []) {
            if (subOpt.name === 'TSP' || subOpt.name === 'PM10') return true;
        }
    }
    return false;
}

const hasPVSOption = (options: OptionContainer[]): boolean => {
    for (const opt of options) {
        if (opt.name === 'PVS') return true;
        for (const subOpt of opt.subOptions || []) {
            if (subOpt.name === 'PVS') return true;
        }
    }
    return false;
}

export default function DataPage() {
  const [record, setRecord] = useState<IDataForm>(new DataFormVal());
  const [sourceTypeOptions, setSourceTypeOptions] = useState<OptionContainer[]>([]);
  const {dataStore, graphStore, userStore} = useStore();
  const { user, CheckIfCastcoAdmin } = userStore;

  const handleExportCurrent = ()=>{
    if(record.locationId>0 ){
      dataStore.exportCurrentLocation(record);
    }
  }

  const handleExportHospitalNose = () => {
    if (record.locationId > 0) {
      dataStore.exportCurrentHospitalNose(record);
    }
  }

  const canShowHospitalNoseExport = !!(user && (CheckIfCastcoAdmin() || user.role === 'Hospital_User') && hasLeq30Option(sourceTypeOptions));

  const handleExportHospitalDust = () => {
    if (record.locationId > 0) {
      dataStore.exportCurrentHospitalDust(record);
    }
  }

  const canShowHospitalDustExport = !!(user && (CheckIfCastcoAdmin() || user.role === 'Hospital_User') && hasTSPOrPM10Option(sourceTypeOptions));

  const handleExportHospitalVibration = () => {
    if (record.locationId > 0) {
      dataStore.exportCurrentHospitalVibration(record);
    }
  }

  const canShowHospitalVibrationExport = !!(user && (CheckIfCastcoAdmin() || user.role === 'Hospital_User') && hasPVSOption(sourceTypeOptions));

  const handleExportAll = ()=>{
    if(record.projectId > 0){
      // Not export all locations in one batch, the file may fail to download.
      // dataStore.exportAllLocations(record);

      // Create the locations IDs and export an excel file for each ID    
      graphStore.getlocationList(record.projectId).then(i => {
          if (i) {
            console.dir(i)
            for (let j = 0; j < i.length; j++) { // loop through the list of location IDs. Export an excel file for each ID.
              const {id, name} = i[j]
              if (!name.includes('no loggerset')) {
                dataStore.exportCurrentLocation(new DataFormVal({
                    ...record,
                    locationId: id
                  })
                  ,name +'.xlsx'
                )
              }
            }
          }
      })
    }
  }

  return (
    <div className="pageParentDiv ">
      <DataPageHeader 
        allBtnisDisabled={record.projectId <= 0} 
        currentBtnisDisabled={record.locationId<=0} 
        exportAll={handleExportAll} 
        exportCurrent={handleExportCurrent}
        exportHospitalNose={handleExportHospitalNose}
        hospitalNoseDisabled={record.locationId <= 0}
        showHospitalNoseExport={canShowHospitalNoseExport}
        exportHospitalDust={handleExportHospitalDust}
        hospitalDustDisabled={record.locationId <= 0}
        showHospitalDustExport={canShowHospitalDustExport}
        exportHospitalVibration={handleExportHospitalVibration}
        hospitalVibrationDisabled={record.locationId <= 0}
        showHospitalVibrationExport={canShowHospitalVibrationExport}
      />
      <DataForm record={record} setRecord={setRecord} sourceTypeOptions={sourceTypeOptions} setSourceTypeOptions={setSourceTypeOptions} />
      <DataViewTable />
    </div>
  )
}
